
import React, { useEffect, useState } from 'react';
import { DefaultButton, IButtonStyles, IDropdownOption, MessageBar, MessageBarType } from '@fluentui/react';
import peripheralService from "../../../../../services/peripheral.service";
import CircleLoader from '../../../../Loader/CircleLoader/CircleLoader';
import { IChoiceField, IField, IFile, IScanner, IScanRequestModel } from '../../../../../shared/interfaces';
import { reduxActions, RootState } from '../../../../../store'
import { store } from '../../../../../index';
import { useSelector } from 'react-redux';
import DynamicForm from '../../../../DynamicForm/DynamicForm';
import { useBoolean } from '@fluentui/react-hooks';
import RippleLoader from '../../../../Loader/RippleLoader/RippleLoader';
import AppUtilities from '../../../../../shared/Utilities/appUtilities';
import axios, { CancelTokenSource } from 'axios';



const uploadButtonStyles: Partial<IButtonStyles> = {
    root: {
        marginTop: 15
    }
}

const initialFields: IField[] = [
    {
        displayName: "Stampanti disponibili",
        internalName: "printerName",
        controlType: "dropdown",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: null,
        valid: false,
        touched: false,
        multi: false,
        options: [] as IDropdownOption[]
    } as IChoiceField
]

export interface PrintLabelProps {
    onSelectePrinter?: (selectedPrinterName: string) => void
}

type Props = PrintLabelProps

const PrintLabel: React.FunctionComponent<Props> = props => {


    const selectCurrentProtocol = (state: RootState) => state.protocolWizardReducer.protocol;
    const currentProtocol = useSelector(selectCurrentProtocol);

    const selectArxeiaConfigurations = (state: RootState) => state.sessionReducer.arxeiaConfigurations;
    const currentArxeiaConfigurations = useSelector(selectArxeiaConfigurations);

    const [messageBarIsVisible, { setTrue: showMessageBar, setFalse: dismissMessageBar }] = useBoolean(false);
    const [messageBarType, setMessageBarType] = useState<MessageBarType>();
    const [messageBarText, setMessageBarText] = useState<string>('');

    const [listPrinters, setListPrinters] = useState<IDropdownOption[]>([]);
    const [fields, setFields] = useState<IField[]>(initialFields);

    const [cancelTokenSources, setCancelTokenSources] = useState<any>({});



    useEffect(() => {

        let peripheralServiceBaseUrl = currentArxeiaConfigurations?.find(el => el.key === "PeripheralServiceBaseUrl")
        if (peripheralServiceBaseUrl && peripheralServiceBaseUrl.value && peripheralServiceBaseUrl.value != '-') {
            peripheralService.setPeripheralServiceBaseUrl(peripheralServiceBaseUrl.value);

            peripheralService.getPrinters()
                .then(result => {
                    const updatedFields = [...fields];

                    let _listPrinters: IDropdownOption[] = result.map((el, index) => {
                        return { key: el, text: el };
                    });

                    updateListOptions(updatedFields, 'printerName', _listPrinters);
                    setFields(updatedFields);
                    setListPrinters(_listPrinters);

                    if (_listPrinters.length === 0) {
                        setMessageBarText("Nessuna stampante disponibile");
                        setMessageBarType(MessageBarType.error);
                        showMessageBar();
                    }
                },
                    error => {
                        setMessageBarText("Servizio di stampa non configurato correttamente");
                        setMessageBarType(MessageBarType.error);
                        showMessageBar();

                    });
        }
        else {
            setMessageBarText('Servizio di stampa non configurato correttamente');
            setMessageBarType(MessageBarType.error);
            showMessageBar();

        }
    }, [currentArxeiaConfigurations]);

    const updateListOptions = (fields: IField[], fieldInternalName: string, newList: IDropdownOption<any>[]) => {
        let field = { ...fields[0] } as IChoiceField;
        field.options = newList;
        field.internalValue = null;
        fields[0] = { ...field };
    }

    const inputChangedHandler = (updatedField: IField) => {

        const updatedFields = [...fields];
        updatedFields[0] = { ...updatedField };

        //seleziono una stampante
        if (updatedField.internalName === 'printerName') {
            let printerName: string = updatedField.internalValue;
            let selectedPrinterOption = listPrinters.find(el => el.key === printerName);
            if (selectedPrinterOption) {
                // gestione opzione stampante selezionata
                setFields(updatedFields);
                if (props.onSelectePrinter) {
                    props.onSelectePrinter(printerName);
                }
                else {
                    store.dispatch(reduxActions.protocolWizardActions.setSelectedPrinterName(printerName))
                }
            }
        }
    }


    return (

        <React.Fragment>
            {messageBarIsVisible &&
                <MessageBar
                    messageBarType={messageBarType}
                    isMultiline={false}
                    truncated={true}
                    onDismiss={dismissMessageBar}
                    dismissButtonAriaLabel="Close">{messageBarText}</MessageBar>
            }

            <DynamicForm
                fields={fields}
                extraCssClass=""
                onInputChangedHandler={(newField) => { inputChangedHandler(newField) }}
            />

        </ React.Fragment>
    )
};


export default PrintLabel;


